import React from 'react';

const LanguageItem = ({language, switchLanguage, handleRequestClose}) => {
  const { name, icon } = language;
  return (
    <li className="pointer" onClick={() => {
      handleRequestClose();
      switchLanguage(language);
    }}>
      <div className="d-flex align-items-center">
        <img src={icon} 
          alt={name} 
          title={name}
          style={{width: '24px'}} />
        <h6 className="mb-0 ml-2">{name}</h6>
      </div>
    </li>
  );
};

export default LanguageItem;
